import { Box, FormGroup } from '@mui/material';
import { WorkType } from '../../../../../enums/work-experience-enum';
import FilterLayout from '../../../../../layouts/FilterLayout';
import { workTypeLabelPlugin } from '../../../../../utils/helper/workTypeEnumValuePlugin';
import CheckBox from './components/CheckBox';

const formatLabel = (label: WorkType) => {
  return workTypeLabelPlugin(label)
    .toLowerCase()
    .replace(/_/g, '-')
    .replace(/^\w/, c => c.toUpperCase());
};

interface ICandidatesWorkTypeFilterProps {
  label: string;
  handleSelectedWorkTypes: (data: string) => void;
  selectedWorkTypes: string[];
}

const CandidatesWorkTypeFilter = (props: ICandidatesWorkTypeFilterProps) => {
  const { label, handleSelectedWorkTypes, selectedWorkTypes } = props;

  return (
    <FilterLayout name={label}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.375rem',
          padding: '0 1rem 1.375rem',
        }}
      >
        <FormGroup>
          {Object.values(WorkType)?.map(workType => (
            <CheckBox
              key={workType}
              label={formatLabel(workType)}
              checked={selectedWorkTypes.includes(workType)}
              onChange={() => handleSelectedWorkTypes(workType)}
            />
          ))}
        </FormGroup>
      </Box>
    </FilterLayout>
  );
};

export default CandidatesWorkTypeFilter;
